<template>
  <div class="dropdown">
    <button v-if="color==='teal'" class="btn-regular" :class="{teal : isSet, secondary : !isSet}" @click.stop="toggledDropdown">{{title}}</button>
    <button v-else class="btn-regular" :class="{pink : isSet, secondary : !isSet}" @click.stop="toggledDropdown">{{title}}</button>
    <media :query="{minWidth: 769}">
      <div v-if="isShown" class="dropdown__menu" @click.stop="isShown = true">
        <div class="dropdown__menu__loading" v-if="loading">
          <adx-loading/>
        </div>
        <div v-else>
        <div v-for="(dropdown, index) in list" :key="index" class="dropdown__menu__item">  
          <div v-if="expand[index]" class="wrapper_content">
            <div class="wrapper_content__title" @click.stop="toogleExpand(index)">
              <span class="strong">{{dropdown.title}}</span>
              <i :class="[ expand[index] ? ' icon-chevronup' : 'icon-chevrondown']"></i>
            </div>
            <div v-if="dropdown.type ==='checkbox'"> 
              <div class="wrapper_content__menu" @click.stop="isShown = true">
                <div class="wrapper_content__menu__wrapper">
                  <multiple-checkbox
                    :value.sync="checkedItem[index]"
                    :options="dropdown.list"
                    :styleClass="`wrapper_content__menu__wrapper__sub__item`"
                    :styleWrapperClass="`wrapper_content__menu__wrapper__sub`"
                  />
                </div>
              </div>  
            </div>
            <div v-else-if="dropdown.type==='list'">
              <div class="wrapper_content__menu" @click.stop="isShown = true">
                <div class="wrapper_content__menu__wrapper">
                  <ul class="wrapper_content__menu__wrapper__list">
                  <li v-for="item in dropdown.list" :key="item.id" @click.stop="select(index, item)"
                    class="wrapper_content__menu__wrapper__list__item">
                    <span class="label subhead">{{ item.label }}</span>
                    <span :class="{'icon-check':isChecked(index, item)}" class="check subhead"></span>
                  </li>
                  </ul>
                </div>
              </div>
            </div> 
            <div v-else>
              <div class="wrapper_content__menu" @click.stop="isShown = true">
                <div class="wrapper_content__menu__wrapper">
                    <div class="wrapper_content__menu__wrapper__range-func">
                      <div class="dd-slider">
                        <div class="dd-slider__rail">
                        </div>
                        <div class="dd-slider__wrapper">
                          <div class="dd-slider__track" ref="dd-slider" :style="{left:valueDragStart+'%', right:100-valueDragEnd+'%'}">
                          </div>
                          <div class="dd-slider__end">
                          </div>
                          <div class="dd-slider__circle-start" :style="{left:valueDragStart+'%'}"></div>
                          <div class="dd-slider__circle-end" :style="{right:100-valueDragEnd+'%'}"></div>
                        </div>
                        <input type="range" class="slider-handle left" ref="dd-slider-left" v-model="valueDragStart" value="0" max="100" min="0"/>
                        <input type="range" class="slider-handle right" ref="dd-slider-right" v-model="valueDragEnd" value="100" max="100" min="0"/>
                      </div>
                    </div>
                    <div class="wrapper_content__menu__wrapper__range-label">
                      <div class="wrapper_content__menu__wrapper__range-label__start subhead">
                        {{getValueStart(dropdown)}} Km
                      </div>
                      <div class="wrapper_content__menu__wrapper__range-label__end subhead">
                        {{getValueEnd(dropdown)}} Km
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div @click.stop="toogleExpand(index)" class="wrapper_content">
              <div class="wrapper_content__title" @click.stop="toogleExpand(index)">
                <span class="strong">{{dropdown.title}}</span>
                <i class="icon-chevrondown"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="dropdown__menu__footer">
          <span @click.stop="reset" class="dropdown__menu__footer__reset color-grey subhead">Reset</span>
          <span @click.stop="apply" class="dropdown__menu__footer__apply color-pink subhead">Apply</span>
        </div>
        </div>
      </div>
    </media>
    <media :query="{maxWidth: 769}">
      <div v-if="isShown">
      <modal v-if="isShown" :title="title" @modal-close="closeDropdown">
      <template slot="content">
        <div class="dropdown__menu__loading" v-if="loading">
          <adx-loading/>
        </div>
        <div v-else class="mainWrapper">
          <div v-for="(dropdown, index) in list" :key="index">
            <div class="wrapper_content" v-if="expand[index]">
              <div class="wrapper-mobile" @click.stop="toogleExpand(index)">
                <span>{{dropdown.title}}</span>
                <i :class="[ expand[index] ? 'icon-chevronup' : 'icon-chevrondown']"></i>
              </div>
              <div v-if="dropdown.type ==='checkbox'"> 
                <div class="dropdown__menu" @click.stop="isShown = true">
                  <div class="dropdown__menu__wrapper-mobile">
                  <multiple-checkbox
                    :value="false"
                    :options="dropdown.list"
                    :styleClass="`dropdown__menu__wrapper-mobile__sub__item`"
                    :styleWrapperClass="`dropdown__menu__wrapper-mobile__sub`"
                  />
                  </div>
                </div>  
              </div>
              <div v-else-if="dropdown.type==='list'">
                <div class="dropdown__menu" @click.stop="isShown = true">
                  <div class="dropdown__menu__wrapper-mobile">
                    <ul class="dropdown__menu__wrapper-mobile__list">
                    <li v-for="item in dropdown.list" :key="item.id" @click.stop="select(index,item)"
                    class="dropdown__menu__wrapper-mobile__list__item" :class="{selected: item.id == selected}">
                      <span class="label subhead">{{ item.label }}</span>
                      <span :class="{'icon-check':isChecked(index, item)}" class="check subhead"></span>
                    </li>
                    </ul>
                  </div>
                </div>
              </div> 
              <div v-else>
                <div class="dropdown__menu__wrapper-mobile">
                  <div class="dropdown__menu__wrapper-mobile__range-func">
                    <div class="dd-slider">
                      <div class="dd-slider__rail">
                      </div>
                      <div class="dd-slider__wrapper-mobile">
                        <div class="dd-slider__track" ref="dd-slider" :style="{left:valueDragStart+'%', right:100-valueDragEnd+'%'}">
                        </div>
                        <div class="dd-slider__end">
                        </div>
                        <div class="dd-slider__circle-start" :style="{left:valueDragStart+'%'}"></div>
                        <div class="dd-slider__circle-end" :style="{right:100-valueDragEnd+'%'}"></div>
                      </div>
                      <input type="range" class="slider-handle left" ref="dd-slider-left" v-model="valueDragStart" value="0" max="100" min="0"/>
                      <input type="range" class="slider-handle right" ref="dd-slider-right" v-model="valueDragEnd" value="100" max="100" min="0"/>
                    </div>
                  </div>
                  <div class="dropdown__menu__wrapper-mobile__range-label">
                    <div class="dropdown__menu__wrapper-mobile__range-label__start subhead">
                      {{getValueStart(dropdown)}} Km
                    </div>
                    <div class="dropdown__menu__wrapper-mobile__range-label__end subhead">
                      {{getValueEnd(dropdown)}} Km
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wrapper_content" v-else>
              <div class="wrapper-mobile" @click.stop="toogleExpand(index)">
                <span>{{dropdown.title}}</span>
                <i class="icon-chevrondown"></i>
              </div>
            </div>
          </div>
          <div class="dropdown__menu__footer">
            <span @click.stop="reset" class="dropdown__menu__footer__reset color-grey subhead">Reset</span>
            <span @click.stop="apply" class="dropdown__menu__footer__apply color-pink subhead">Apply</span>
          </div>
        </div>
      </template>
      </modal>
      </div>
    </media>
  </div>
</template>

<script>
import Vue from 'vue'
import Media from 'vue-media'
import Modal from '@/components/Modal'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdown'
import DropdownList from '@/components/Dropdown/ListDropdown'
import DropdownSort from '@/components/Form/SelectDropdown'
import MultipleCheckbox from '@/components/Form/MultipleCheckbox'
import LoadingPrimary from '@/components/Loading/Primary'

export default {
  name: 'adx-dropdown-list',
  components: {
    'media': Media,
    'modal': Modal,
    'adx-dropdown-checkbox': DropdownCheckbox,
    'adx-dropdown-list': DropdownList,
    'adx-dropdown-sort': DropdownSort,
    'multiple-checkbox': MultipleCheckbox,
    'adx-loading': LoadingPrimary,
  },
  props: {
    loading: {
      required: false,
      default: false,
    },
    list: {
      type: Array,
      required: true,
    },
    title: {
       required: false,
       default: 'More Filters'
    },
    color: {
      required: false,
      default: 'teal'
    },
    isReset: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      checkedItem: [],
      expand: [],
      firstLabelDropdown: '',
      isShown: false,
      isSet: false,
      labelDropdown: '',
      selected: [],
      valueDragStart:0,
      valueDragEnd:100,
    }
  },
  computed: {
    // isSet: function () {
    //   return this.checkedItem.length > 0 ? true : false
    // },
  },
  watch: {
    'isReset': function(after, before) {
      if (this.isReset) {
        this.reset()
      }
    },
    labelButton() {
      this.labelDropdown = this.labelButton
    },
    'valueDragStart': function (after, before){
      if (parseInt(after) > parseInt(this.valueDragEnd)) {
        this.valueDragStart = this.valueDragEnd
      } else {
        let rightCircle = this.$refs['dd-slider'][0]
        if (rightCircle) { rightCircle.style.left = this.valueDragStart+'%;' }    
      }
    },
    'valueDragEnd': function (after, before){
      if (parseInt(after) < parseInt(this.valueDragStart)){
        this.valueDragEnd = this.valueDragStart
      } else {
        let rightCircle = this.$refs['dd-slider'][0]
        if (rightCircle) { rightCircle.style.right = this.valueDragEnd+'%;' }
      }
    },
    valueDisplay() {
      if (!this.valueDisplay) {
        this.labelDropdown = this.firstLabelDropdown
        this.isSet = false
        this.selected = null
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
    this.labelDropdown = this.labelButton
    this.firstLabelDropdown = this.labelButton
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.closeDropdown()
      }
    })
    this.initialExpandValue()
  },
  updated() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
  },
  methods: {
    reset(){
      this.checkedItem = []
      this.selected = []
      this.valueDragStart = 0
      this.valueDragEnd = 100
      this.isSet = false
      // this.closeDropdown()
      this.initialExpandValue()
    },
    apply(){
      let isSelectedExist = false
      let res = []
      this.list.forEach((dropdown, index) => {
        if (dropdown.type === 'checkbox') {
          if (this.checkedItem[index] && this.checkedItem[index].length) isSelectedExist = true
          res.push({
            title: dropdown.title,
            type: dropdown.type,
            result: this.checkedItem[index] || []
          })
        } else if (dropdown.type === 'list') {
          let selectedDropdown = this.getSelected(index, dropdown.list)
          if (selectedDropdown) isSelectedExist = true
          res.push({
            title: dropdown.title,
            type: dropdown.type,
            result: selectedDropdown
          })
        } else {
          let start = this.getValueStart(dropdown)
          let end = this.getValueEnd(dropdown)
          let rangeResult = null
          if (start != dropdown.minValue || end != dropdown.maxValue) {
            rangeResult = {
              min: start,
              max: end
            }
            isSelectedExist = true
          }
          res.push({
            title: dropdown.title,
            type: dropdown.type,
            result: rangeResult
          })
        }
      })
      this.isSet = isSelectedExist
      this.closeDropdown()
      this.$emit('apply', res)
    },
    getSelected(index, dropdown){
      let selected = dropdown.filter(item => { return this.selected[index] == item.id})
      if (selected.length){
        return selected[0]
      } 
      return null
    },
    getValueStart(dropdown){
      let valueStart = this.valueDragStart
      return Math.round((valueStart /100) * (dropdown.maxValue - dropdown.minValue))
    },
    getValueEnd(dropdown){
       let valueEnd = this.valueDragEnd
       return Math.round((valueEnd /100) * (dropdown.maxValue - dropdown.minValue))
    },
    initialExpandValue(){
      for(let i = 0; i<this.list.length;i++){
        this.expand.push(false)
        this.checkedItem.push([])
        this.selected.push(null)
      }
    },
    toogleExpand(index){
        let val = this.expand[index]
        this.$set(this.expand, index, !val)
    },
    toggledDropdown(sender) {
      Vue.$broker.$emit("app-click", this)
      this.isShown = !this.isShown
    },
    closeDropdown(sender) {
      if (sender === this) {
        return
      }
      this.isShown = false
    },
    isChecked(index, item){
      if (this.selected[index] == item.id) return true
      return false
    },
    select(index, item) {
      if (this.selected[index] == item.id){
        this.$set(this.selected, index, null)
      } else {
        this.$set(this.selected, index, item.id)
      }
    },
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>